module.exports = __webpack_public_path__ + "img/portraits_03_H.430288fb.webp";